import formName from 'constants/formName'
import { actions } from 'data'
import { call, put } from 'redux-saga/effects'

import { goToStep } from './common'

export default function* ssnStep() {
  yield put(actions.auth.getUser())
  yield put(actions.form.change(formName.TIER_TWO, 'loading', false))
  yield call(goToStep, 'preIdv')
}
